/*
 * @Author: your name
 * @Date: 2021-05-14 09:13:39
 * @LastEditTime: 2021-06-09 16:33:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \auxh5ui\onlineH5\privacy_notice\src\assets\languageData.js
 */
import ACFreedom from './ac_freedom.js'
import ACComfort from './ac_comfort.js'
//获取url 参数
export function getUrlParamsNew(queryName) {
    if (!queryName || !window.location.href.split('?')[1]) {
        return '';
    }
    var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
    var search = window.location.href.split('?')[1] || '';
    var formatSearch = search ? search.split("#")[0] : ""
    var r = formatSearch.match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    } else {
        return null;
    }
}
let langdata;
let appLocale = getUrlParamsNew("language") || "";
let app = getUrlParamsNew("app") || "";
console.log('appName:', app)
appLocale = appLocale ? appLocale : (typeof navigator === 'undefined' ? 'en' :
            ((navigator.languages && navigator.languages[0]) ||
            navigator.language ||
            navigator.userLanguage));
appLocale = appLocale.toLowerCase();
console.log(appLocale,'appLocale')
let textData = ACFreedom;
if (app == 'com.auxgroup.rheem' || app == 'com.auxgroup.ruud') {
  console.log('为 AC comfort app')
  textData = ACComfort;
}
if(appLocale.indexOf('en') >= 0 ){
    langdata = textData.en;
}
if(appLocale.indexOf('it') >= 0 ){
    langdata = textData.it
}
if(appLocale.indexOf('el') >= 0 ){
    langdata = textData.el
}
if(appLocale.indexOf('es') >= 0 ){
    langdata = textData.es
}
if(appLocale.indexOf('sr') >= 0 ){
    langdata = textData.sr
}
if(appLocale.indexOf('pt') >= 0 ){
    langdata = textData.pt
}
if(appLocale.indexOf('ro') >= 0 ){
    langdata = textData.ro
}
if(appLocale.indexOf('ba') >= 0 ){
    langdata = textData.ba
}
if(appLocale.indexOf('hu') >= 0 ){
    langdata = textData.hu
}
if(!langdata){
    langdata = textData.en;
}

export default langdata


// WEBPACK FOOTER //
// ./src/assets/languageData.js